import {normalize} from '../../util/utils';
import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {HttpStatusCodes} from '../../util/uiconstants';
import _ from 'lodash';

const deleteSCOTFromStore = (scotId, state, isManageScots = false) => {
	if (isManageScots) {
		let newState = _.cloneDeep(state);
		if (state.manageScots) {
			newState.manageScots.data = state.manageScots.data.filter((scot) => {
				return scot.id !== scotId;
			});
		}
		return newState;
	}
	return {
		...state,
		byId: {
			...state.byId
		},
		allIds: state.allIds.filter((id) => {
			return id !== scotId;
		})
	};
};

export function scotsDetailsReducer(state = initialstate.scotsDetails, action) {
	switch (action.type) {
		case types.GET_SCOT_BY_ID:
			return action.response || state;
		case types.CLEAN_SCOT:
			return initialstate.scotsDetails;
		default:
			return state;
	}
}

export function scotsReducer(state = initialstate.scots, action) {
	switch (action.type) {
		case types.GET_SCOTS_FOR_ASSERTIONID:
			return action.response || state;

		case types.SAVE_RISK_WCGW_SELECTION: {
			let temp = [{}];
			Object.assign(temp, state);

			temp[0].scots.map((x) => {
				if (x.scotId === action.scotId) {
					for (let i = 0; i < action.data.length; i++) {
						let actionWcgw = action.data[i];
						for (let j = 0; j < x.wcgws.length; j++) {
							if ('/Wcgw/' + x.wcgws[j].wcgwId === actionWcgw.id) {
								x.wcgws[j] = {...x.wcgws[j], selected: actionWcgw.checked};
							}
						}
					}
				}
				return x;
			});
			return temp || state;
		}

		case types.GET_ENGAGEMENT_ALL_SCOTS:
			if (action.response && action.response.data && !action.error) {
				if (action?.isManageScots) {
					let newState = _.cloneDeep(state);
					return {...newState, manageScots: action.response};
				}
				const scotsList = normalize(action.response.data);
				scotsList.pages = action.response.pages;
				scotsList.page = action.response?.page;
				scotsList.totalEntityCount = action.response.totalEntityCount;
				return {...state, ...scotsList};
			}
			return state;

		case types.CREATE_SCOT:
			if (action.response && !action.error) {
				let newState = _.cloneDeep(state);

				if (action.isManageScots) {
					newState.manageScots = newState.manageScots || {};
					newState.manageScots.data = [...(state.manageScots?.data || []), action.response];
					return newState;
				}

				newState = action.response;
				newState.byId = {
					...state.byId,
					[action.response.id]: action.response
				};
				newState.allIds = [...(state.allIds || []), action.response.id];
				return newState;
			}
			return state;

		case types.GET_SCOT_BY_ID:
			if (action?.error?.response?.status === HttpStatusCodes.NotFound) {
				return deleteSCOTFromStore(action.scotId, state, action?.isManageScots); // If the Scot is not found, remove it from the list (concurrency scenario)
			}
			return state;

		case types.UPDATE_SCOT: {
			if (action.response && !action.error && Object.keys(state).length > 0) {
				let newState = _.cloneDeep(state);
				if (action.isManageScots) {
					if (!newState.manageScots) {
						newState.manageScots = {data: [action.response]};
					} else if (newState.manageScots.data.length === 0) {
						newState.manageScots.data = [action.response];
					} else {
						const updatedScots = newState.manageScots.data.filter((e) => e.id !== action.response.id);
						newState.manageScots.data = [...updatedScots, action.response];
					}
				}

				newState.byId = {
					...state?.byId,
					[action.response.id]: {
						...[state?.byId && state?.byId[action.response.id]],
						...action.response
					}
				};

				return newState;
			} else if (action?.error?.response?.status === HttpStatusCodes.BadRequest) {
				// If the Scot is not found, remove it from the list (concurrency scenario)
				return deleteSCOTFromStore(action?.meta?.api?.data?.id, state, action?.isManageScots);
			}
			return state;
		}

		case types.GET_SCOTS_BY_ENG:
			return action.response?.data || state;

		case types.DELETE_SCOT: {
			if (
				action.responseObj.status === HttpStatusCodes.NoContent ||
				action.error.response.status === HttpStatusCodes.NotFound
			) {
				return deleteSCOTFromStore(action.scotId, state, action?.isManageScots);
			}
			return state;
		}
		default:
			return state;
	}
}

// pull scots from api results
export function formatScots(scots) {
	let formattedScots = {};
	if (scots && scots[0] && scots[0].scots && scots[0].scots.length > 0) {
		formattedScots = scots[0].scots;
		formattedScots.riskId = scots[0].riskId;
		formattedScots.assertionId = scots[0].assertions[0].id;
	}
	return formattedScots;
}

export function scotReducer(state = initialstate.scot, action) {
	switch (action.type) {
		case types.CREATE_SCOT:
			if (action.response && !action.error) {
				let newState = _.cloneDeep(state);

				if (action.isManageScots) {
					let newState = _.cloneDeep(state);
					if (newState?.manageScots?.data) {
						let scotsData = newState.manageScots.data.filter((e) => e.id !== action.response.id);
						newState.manageScots.data = [...scotsData, action.response];
					}
					return newState;
				}
				newState = action.response;
				return newState;
			}
			return state;
		default:
			return state;
	}
}
